import { gql } from 'apollo-boost';

export const MODIFY_CART_PRESCRIPTION = gql`
  mutation doModifyCartPrescription($id: ID!, $data: CartPrescriptionInput!) {
    modifyCartPrescription(id: $id, data: $data) {
      id
      leftEyeProductVariant {
        id
        title
        handle
        attributes {
          attribute {
            id
            value
          }
        }
        details {
          productId
          productHandle
          productVariantId
          productVariantHandle
          packSize
          power
          baseCurve
          diameter
          sphere
          cylinder
          axis
          shape
          colour
          volume
        }
        locales {
          id
          region
          title
          sku
          stock
          pricing {
            quantity
            basePrice
            actualPrice
          }
          shippingOptions {
            shippingOption {
              id
              price
              handle
            }
          }
        }
      }
      rightEyeProductVariant {
        id
        title
        handle
        attributes {
          attribute {
            id
            value
          }
        }
        details {
          productId
          productHandle
          productVariantId
          productVariantHandle
          packSize
          power
          baseCurve
          diameter
          sphere
          cylinder
          axis
          shape
          colour
          volume
        }
        locales {
          id
          region
          title
          sku
          stock
          pricing {
            quantity
            basePrice
            actualPrice
          }
          shippingOptions {
            shippingOption {
              id
              price
              handle
            }
          }
        }
      }
    }
  }
`;
